import {ApiDefinition} from "./ApiDefinition";
import {APIPromise, queryClient} from "../services/HttpService";
import {FileQueryKey} from "./api-hooks/file-hooks";
import {AxiosProgressEvent} from "axios";
import {InstantString} from "./model/general/aliases";

export interface FileUploadDTO {
    fileName: string;
    downloadUrlPart: string;
    isPublic: boolean;
    description: string;
    tags: string[];
    createdBy: number;
    createdAt: InstantString;
    editedAt: InstantString;
}


class FilesApiDefinition extends ApiDefinition {
    constructor() {
        super("/files");
    }

    async getPublicFiles(): APIPromise<FileUploadDTO[]> {
        return this.get("public");
    }

    async getCompanyFiles(): APIPromise<FileUploadDTO[]> {
        return this.get("company");
    }

    async uploadFile(file: File, desc?: string, tags?: string[], progressCallback?: (percent: number) => void): APIPromise<FileUploadDTO> {
        const ret = await this.uploadFileCommon("upload", file, desc, tags, progressCallback);

        if(ret.data) {
            queryClient.setQueryData([FileQueryKey.COMPANY_FILES], (e: FileUploadDTO[]) => {
                return [ret.data!!, ...e];
            });
        }

        return ret;
    }

    async uploadPublicFile(file: File, desc?: string, tags?: string[], progressCallback?: (percent: number) => void): APIPromise<FileUploadDTO> {
        const ret =  await this.uploadFileCommon("public/upload", file, desc, tags, progressCallback);

        if(ret.data) {
            queryClient.setQueryData([FileQueryKey.PUBLIC_FILES], (e: FileUploadDTO[]) => {
                return [ret.data!!, ...e];
            });
        }

        return ret;
    }

    async deleteCompanyFile(downloadUrlPart: string): APIPromise<FileUploadDTO> {
        return this.delete("company/" + downloadUrlPart);
    }

    async deletePublicFile(downloadUrlPart: string): APIPromise<FileUploadDTO> {
        return this.delete("public/" + downloadUrlPart);
    }


    downloadPublicFileUrl(downloadUrlPart: string): string {
        return this.getFullUrl("public/download/" + downloadUrlPart);
    }

    downloadCompanyFileUrl(downloadUrlPart: string): string {
        return this.getFullUrl("download/" + downloadUrlPart);
    }

    // ====================== Common ======================
    private async uploadFileCommon(urlPath: string, file: File, desc?:string,  tags?: string[], progressCallback?: (percent: number) => void): APIPromise<FileUploadDTO> {
        const formData = new FormData();
        formData.append('file', file);

        if (tags) {
            tags.forEach(tag => formData.append('tags', tag));
        }
        if(desc) {
            formData.append('description', desc);
        }

        const headers = {
            'Content-Type': 'multipart/form-data',
            // Add file size
            'Content-Disposition': 'attachment; filename=' + file.name + '; size=' + file.size + ';'
        };


        const cb = (progressEvent: AxiosProgressEvent) => {
            if(progressCallback) {
                let percent = (progressEvent.loaded * 100) / progressEvent.total!!;
                // round to 2 decimal places
                percent = Math.round(percent * 100) / 100;
                progressCallback(percent);
            }
        }


        return this.post(urlPath, formData, {headers: headers, onUploadProgress: cb});
    }
}

export const FilesApi = new FilesApiDefinition();